import { PropertyType, ToolProvider } from '@/backend/types'
import { defaultToolConfig } from '@/modules/Project/Tools/tool-config-presets'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

export const claude37ThinkingTool: ToolRegistryItem = {
  ...defaultToolConfig,
  label: 'Claude 3.7 Thinking',
  addedAt: new Date('2024-01-01'),
  description:
    'Claude 3.7 Thinking is optimized for complex reasoning tasks where accuracy is critical. While slower than Claude 3.7 Sonnet, it excels at complicated problems requiring deep analysis.',
  outputTypes: [
    PropertyType.text,
    PropertyType.single_select,
    PropertyType.multi_select,
    PropertyType.hub_select,
    PropertyType.json,
    PropertyType.collection,
    PropertyType.url,
  ],
  provider: ToolProvider.anthropic,
  icon: 'company-anthropic',
  deprecated: true,
}
